import Query from "./query/index.js";
import QualityControl from "./quality_control/index.js";
import Reporting from "./reporting/index.js";
import QualityReports from "./quality_reports/index.js";

export default [...Query, ...QualityControl, ...Reporting, ...QualityReports];
